import { errorHandler } from '../../../utils';
import {
  FormInfoBuilder,
  GetJobPositionsInput,
  GetJobPositionsOutput,
} from '../form-info.types';

export const getJobPositionsIdAndTitle = (builder: FormInfoBuilder) =>
  builder.query<GetJobPositionsOutput, GetJobPositionsInput>({
    query: () => ({
      url: '/job-positions',
      method: 'GET',
    }),
    keepUnusedDataFor: 240,
    providesTags: (result) =>
      result
        ? [
            ...result.map(({ Id }) => ({
              type: 'JobPositions' as const,
              id: Id,
            })),
            { type: 'JobPositions' },
          ]
        : [{ type: 'JobPositions' }],
    transformErrorResponse: (err, meta, args) => {
      const { t } = args;
      errorHandler(
        '[GetJobPositionsIdAndTitle]',
        t('errorMessages.getInfoFail'),
        err,
        true
      );
      return err.data;
    },
  });
